import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axios, { AxiosError } from "axios";
import { buildStaffResourcePathForCurrentUser } from "../ResourceBuilder";

export type AccountPatientProblem = {
    accountPatientId: number;
    diagnosisText: string;
    diagnosisCode: string;
    severity: number;
    status: number;
    comment: string;
    active: boolean;
};

export type AccountPatientProblemsRecord = {
    problems: AccountPatientProblem[];
    problemKnownStatus: number;
    patientFullName: string;
};

const accountPatientApi = createApi({
    reducerPath: "lobbie/staff/account/patients",
    baseQuery: fetchBaseQuery({}),
    endpoints: (builder) => {
        return {
            getHealthProfileProblems: builder.query<AccountPatientProblemsRecord, number>({
                queryFn: async (id) => {
                    const url = buildStaffResourcePathForCurrentUser(
                        `/account_patients/health-profile/problems?accountPatientId=${id}`,
                    );
                    try {
                        const response = await axios.get<AccountPatientProblemsRecord>(url, {
                            withCredentials: true,
                        });
                        return { data: response.data };
                    } catch (error) {
                        const axiosError = error as AxiosError;
                        return {
                            data: undefined,
                            error: {
                                error: axiosError.message,
                                originalStatus: axiosError.response?.status ?? 0,
                                status: axiosError.status ?? 0,
                                data: axiosError.response?.data,
                            },
                        };
                    }
                },
            }),
        };
    },
});

export const { useGetHealthProfileProblemsQuery } = accountPatientApi;

export default accountPatientApi;
